import { graphql } from '@gql';

/**
 * Cursor-capable asset-items query. `GetAssetItems` in `./assets.ts` has no
 * `$after`/`pageInfo`, so it cannot back a paged `GraphQLTableAdapter`; this
 * document is additive and that one is untouched.
 *
 * It lives under `api/` because codegen only scans `src/api/**` — a document
 * outside that glob is never registered, and `graphql()` then returns `{}`.
 */
export const GET_ASSET_ITEMS_PAGED = graphql(`
    query GetAssetItemsPaged(
        $first: Int
        $last: Int
        $after: Cursor
        $before: Cursor
        $where: AssetItemWhereInput
        $orderBy: AssetItemOrder
    ) {
        assetItems(
            where: $where
            first: $first
            last: $last
            after: $after
            before: $before
            orderBy: $orderBy
        ) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
            edges {
                node {
                    ...FullAssetItemFragment
                    asset {
                        ...AssetSummaryFragment
                    }
                }
            }
        }
    }
`);
